import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { SubContractor } from '../materials/subContractors';

export interface DailySubContractor {
    _id: string;
    activityId: string;
    subContractorTypeId: SubContractor;
    durationDay: number;
    state: number;
    includedInExpenses?: boolean;
    price?: number;
    priceType?: number;
}

export interface DeleteDailySubContractorResponse {
    message: string;
    data: DailySubContractor;
}

export const deleteDailySubContractor = async (id: string): Promise<DeleteDailySubContractorResponse> => {
    try {
        const response: AxiosResponse<DeleteDailySubContractorResponse> = await apiClient.delete(`/daily-subcontractors/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateDailySubContractorResponse {
    message: string;
    data: DailySubContractor;
}

export interface CreateDailySubContractorBody {
    activityId: string;
    subContractorTypeId?: string;
    price?: number;
    priceType?: number;
    includedInExpenses?: boolean;
}

export const createDailySubContractor = async (body: CreateDailySubContractorBody): Promise<CreateDailySubContractorResponse> => {
    try {
        const response: AxiosResponse<CreateDailySubContractorResponse> = await apiClient.post('/daily-subcontractors', {
            durationDay: 1,
            ...body,
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface DailySubContractorResponse {
    message: string;
    data: DailySubContractor;
}

export interface UpdateDailySubContractorBody {
    activityId?: string;
    subContractorTypeId?: string;
    durationDay?: number;
    state?: number;
    price?: number | null;
    priceType?: number | null;
    includedInExpenses?: boolean;
}

export const updateDailySubContractor = async (id: string, body: UpdateDailySubContractorBody): Promise<DailySubContractorResponse> => {
    try {
        const response: AxiosResponse<DailySubContractorResponse> = await apiClient.patch('/daily-subcontractors/' + id, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
